// ─────────────────────────────────────────────────────────────────────────────
// categories.js 
// ─────────────────────────────────────────────────────────────────────────────

export const productCategories = [
  {
    id:          'vitamin-mineral-supplements',
    label:       'Vitamin & Mineral Supplements',
    description: 'Water-soluble vitamin and mineral supplements to support immunity, fertility, and overall animal health.',
    color:       'green',
  },
  {
    id:          'gut-health',
    label:       'Gut Health',
    description: 'Probiotics, prebiotics, and organic acids that maintain a healthy gut microbiome and improve digestion.',
    color:       'amber',
  },
  {
    id:          'respiratory-health',
    label:       'Respiratory Health',
    description: 'Essential oil-based and natural solutions targeting respiratory health and airway function in livestock.',
    color:       'green',
  },
  {
    id:          'antibiotic-alternatives',
    label:       'Antibiotic Alternatives',
    description: 'Science-backed natural alternatives to antibiotics for disease prevention and flock/herd health management.',
    color:       'amber',
  },
  {
    id:          'feed-additives',
    label:       'Feed Additives',
    description: 'Enzymes, emulsifiers, organic acids, and disinfectants that enhance feed quality and farm biosecurity.',
    color:       'green',
  },
  {
    id:          'premix',
    label:       'Vitamin & Mineral Premix',
    description: 'Complete, homogeneous vitamin and mineral premixes for broiler, layer, and breeder feed formulation.',
    color:       'amber',
  },
  {
    id:          'electrolytes',
    label:       'Electrolytes & Energy',
    description: 'Electrolyte and energy supplements for heat stress management, post-partum recovery, and diarrhea control.',
    color:       'green',
  },
  {
    id:          'liver-health',
    label:       'Liver Health',
    description: 'Liver cell protectants and hepatoprotective products targeting fatty liver and infectious bronchitis recovery.',
    color:       'amber',
  },
]

// ── Livestock Sectors ─────────────────────────────────────────────────────────
// Source: client confirmed - Poultry and Dairy are primary sectors
export const sectors = [
  {
    id:          'poultry',
    label:       'Poultry',
    description: 'Broilers, layers, breeders, and hatcheries - complete nutritional programmes for poultry production.',
    icon:        'poultry',
    subspecies:  ['Broiler', 'Layer', 'Breeder', 'Hatchery'],
  },
  {
    id:          'dairy',
    label:       'Dairy',
    description: 'Calves, heifers, and milking cows - solutions for milk yield, health, and metabolic performance.',
    icon:        'dairy',
    subspecies:  ['Calves', 'Heifers', 'Milking Cows'],
  },
  {
    id:          'swine',
    label:       'Swine',
    description: 'Piglets, growers, and sows - nutritional solutions for performance, gut health, and reproductive success.',
    icon:        'swine',
    subspecies:  ['Piglet', 'Grower', 'Finisher', 'Sow'],
  },
  {
    id:          'multi',
    label:       'Multi-Species',
    description: 'Products suitable for use across multiple species including poultry, dairy, and hatchery applications.',
    icon:        'ruminant',
    subspecies:  [],
  },
]

// ── Client types ──────────────────────────────────────────────────────────────
export const clientTypes = [
  { id: 'feed-millers',   label: 'Feed Millers' },
  { id: 'integrators',   label: 'Integrators' },
  { id: 'veterinarians', label: 'Veterinarians' },
  { id: 'producers',     label: 'Commercial Producers' },
]